import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="editor_ordered_list-a"
            d="M3,8 L3,9 L4,9 L4,10 L1,10 L1,9 L2,9 L2,8 L1,8 L1,7 L4,7 L4,8 L3,8 Z M4,12 L4,13 L4,14 L1,14 L1,13 L2,13 L2,12 L1,12 L1,11 L4,11 L4,12 Z M3,5 L4,5 L4,6 L1,6 L1,5 L2,5 L2,4 L1,4 L1,3 L2,3 L3,3 L3,5 Z M5.5,4 L13.5,4 C13.7761424,4 14,4.22385763 14,4.5 C14,4.77614237 13.7761424,5 13.5,5 L5.5,5 C5.22385763,5 5,4.77614237 5,4.5 C5,4.22385763 5.22385763,4 5.5,4 Z M5.5,8 L13.5,8 C13.7761424,8 14,8.22385763 14,8.5 C14,8.77614237 13.7761424,9 13.5,9 L5.5,9 C5.22385763,9 5,8.77614237 5,8.5 C5,8.22385763 5.22385763,8 5.5,8 Z M5.5,12 L13.5,12 C13.7761424,12 14,12.2238576 14,12.5 C14,12.7761424 13.7761424,13 13.5,13 L5.5,13 C5.22385763,13 5,12.7761424 5,12.5 C5,12.2238576 5.22385763,12 5.5,12 Z"/>
    </defs>
    <g>
      <use xlinkHref="#editor_ordered_list-a"/>
    </g>
  </svg>
);
